<template>
  <!-- 一对一咨询内容页 -->
  <div class="otocoudet">
    <div class="w12 between">
      <div class="otocoudetlf">
        <otodetstrter class="bgff" />
        <otodetxgflzx class="mt30" />
        <otodetflzs class="bgff mt30" />
        <otodetrmflzx class="bgff mt30" />
      </div>
      <div class="otocoudetrg">
        <otodetusercol />
        <otodetzyls class="mt30 bgff" />
      <articlelist class="mt30 bgff" :num="4" title="精选解答推荐" />
      </div>
    </div>
  </div>
</template>

<script>
import otodetstrter from "./child/otodetstrter";
import otodetusercol from "./components/otodetusercol";
import otodetzyls from "./components/otodetzyls";
import otodetxgflzx from "./child/otodetxgflzx";
import otodetflzs from "./child/otodetflzs";
import otodetrmflzx from './child/otodetrmflzx'
import articlelist from "views/videoclaim/componens/articlelist";
export default {
  components: {
    otodetstrter,
    otodetusercol,
    otodetxgflzx,
    otodetzyls,
    otodetflzs,
    otodetrmflzx,
    articlelist,
  },
};
</script>

<style lang="scss" scoped>
.otocoudet {
  background: #f8f8f8;
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    align-items: flex-start;
    .bgff {
      background: #ffffff;
    }
    .otocoudetlf {
      width: 890px;
    }
    .otocoudetrg {
      width: 280px;
    }
  }
}
</style>